import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function NotFound() {
  useDocumentMeta('Page Not Found | Redline Garage', 'The page you requested could not be found. Return to the Redline Garage homepage.');

  return (
    <SiteLayout>
      <section className="min-h-[70vh] flex items-center pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="w-full mx-auto max-w-[1280px] px-4 md:px-8 lg:px-10">
          <span className="block w-10 h-[2px] bg-primary-500" aria-hidden="true" />
          <p className="mt-6 text-[11px] uppercase tracking-[0.24em] text-foreground-600 font-label">Error 404</p>
          <h1 className="mt-3 font-heading uppercase text-[44px] md:text-[72px] leading-[0.92] text-foreground-950">Page not found.</h1>
          <p className="mt-5 text-[15px] text-foreground-700 max-w-md leading-relaxed">The page you&apos;re looking for has moved or no longer exists.</p>
          <Link to="/" className="group mt-9 inline-flex items-center gap-3 min-h-[44px] text-[13px] font-semibold uppercase tracking-[0.16em] text-foreground-950 whitespace-nowrap cursor-pointer">
            <span className="border-b border-foreground-600 group-hover:border-primary-500 pb-1 transition-colors">Back to Home</span>
            <span className="w-4 h-4 flex items-center justify-center text-primary-500"><i className="ri-arrow-right-up-line" /></span>
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}